var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDb5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M0 0L0 500L500 500L500 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M57 107L58 108L57 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M49 171C54.0615 169.915 52 160.288 52 156L52 122C52 116.847 52.3143 111.572 58 109.5C66.4302 106.427 80.0398 109 89 109L159 109L337 109C364.972 109 399.498 103.76 426 112C420.369 105.074 411.022 108 403 108L342 108L133 108C115.054 108 96.9279 108.746 79 107.961C71.7316 107.642 61.6852 104.649 55.044 108.858C48.271 113.151 49.9671 120.249 49.9992 127C50.0659 141.003 52.2487 157.354 49 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M74 107L74 108L416 108L385 107L316 107L74 107M420 107L421 108L420 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M421 107L422 108L421 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M57 109L58 110L57 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M62 171C62.0598 164.31 63.8531 157.905 71.0008 155.653C78.0902 153.418 87.6163 155 95 155L145 155C154.043 155 163.241 153.445 169.775 161.019C177.243 169.673 174 186.32 174 197L174 279C174 288.588 177 304.458 172.062 312.995C168.085 319.871 161.872 319.513 155 320.17C141.723 321.438 128.348 321 115 321C111.979 321 93.8741 320.673 101.604 328.258C105.145 331.733 114.452 330 119 330L166 330L353 330L405 330C410.308 330 420.363 331.922 424.258 327.427C427.096 324.153 426 317.998 426 314L426 281C426 275.215 426.834 268.676 425.61 263C424.568 258.174 421.347 254.115 421.347 249C421.347 243.198 425.528 238.677 425.945 233C426.905 219.944 424.333 206.991 424.015 194C423.652 179.187 425.639 164.872 425 150L424 150L423 157C414.892 155.073 408.809 147.218 401 145.938C375.614 141.773 345.797 146 320 146L151 146C125.62 146 97.8718 149.131 73 144L73 143L383 143C383.332 138.936 386.247 122.17 393.566 126.137C397.839 128.452 394.882 139.298 394 143L400 143C394.889 126.876 407.332 109.866 425 113C419.005 107.017 408.842 109 401 109L339 109L139 109L82 109C74.7051 109 63.8623 107.007 57.0941 110.009C50.3078 113.019 52 121.968 52 128L52 158C52 161.122 50.9544 166.778 53.0278 169.397C54.8884 171.746 59.3743 170.998 62 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M420 109L421 110L420 109M424 109L425 110L424 109M55 110L56 111L55 110M422 110L423 111L422 110M425 110L426 111L425 110M426.333 111.667L426.667 112.333L426.333 111.667M53 112L54 113L53 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M398 143L398 144L423 157L424 150L410 151L410 150C419.714 149.92 429.228 147.122 434 138L435 138L434 141L435 141C442.264 127.142 435.338 120.975 426 112C413.96 112.639 402.465 115.737 398.638 129C397.416 133.236 400.169 139.685 398 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M50 113L51 114L50 113M49 116L50 117L49 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M49 119L49 170L50 170C50 155.689 54.5084 132.127 49 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M383 143C385.928 143 390.948 143.91 393.397 141.972C400.437 136.399 392.92 116.318 385.919 130.044C385.125 131.601 384.616 133.319 384.159 135C383.435 137.663 383.12 140.255 383 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M435 137L436 138L435 137M434 138C427.813 146.052 420.113 149.79 410 150L410 151L426 149L426 172L427 172L427.603 150L434 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M433 142L434 143L433 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M73 143L74 144L73 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M74 143L74 144L334 144L310 143L257 143L74 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M76 144L76 145L401 145C394.147 140.895 382.775 143 375 143C353.948 143 333.011 144 312 144L76 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M432 143L433 144L432 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M75 144L76 145L75 144M401 144L402 145L401 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M431 144L432 145L431 144M79 145L79 146L349 146L324 145L269 145L79 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M349 145L350 146L349 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M350 145L351 146L350 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M351 145L351 146L359 146L351 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M359 145L359 146L368 146L359 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M368 145L368 146L390 146L368 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M390 145L390 146L401 146L390 145M430 145L431 146L430 145M429 146L430 147L429 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M428 147L426.91 168L427 234L429 234L428.004 182L428 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M360 148L361 149L360 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M428 148L428 158L429 158L428 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M198 259C205.229 245.197 215.48 220.931 228.019 211.565C236.443 205.272 246.902 201.237 256 196C259.163 194.179 264.505 192.755 265 189L269 190L269 189L267 189L267 188L283 188L283 187L281 187L281 186C283.648 186.499 288.452 188.283 289 185L304 185L304 184L302 184C320.24 180.763 335.179 171.941 352 163.895C355.707 162.122 370.653 155.376 360.606 150.133C357.417 148.469 352.76 151.868 350 153.247L324 166.247C303.873 176.31 283.929 174.371 263 180.634C250.199 184.465 235.293 194.275 224.015 201.468C213.458 208.2 206.874 224.6 200.319 235C197.657 239.222 193.267 244.16 191.951 249C190.724 253.516 194.392 257.155 198 259M409 149L410 150L409 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M425 149L425 156L426 156L425 149M362 151L363 152L362 151M363 153L364 154L363 153M70 155L71 156L70 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M62 171L32 171C28.0125 171 21.9686 169.888 18.2785 171.603C14.8677 173.189 15.043 177.829 15.0039 181C14.9083 188.736 11.653 207.512 16.7423 213.682C19.7587 217.339 26.8111 216 31 216L68 216C72.1889 216 79.2413 217.339 82.2577 213.682C84.7562 210.653 83.9998 205.64 84 202L84 174L85 174C90.3802 184.63 90 192.983 90 205C90 208.946 91.1937 215.367 86.8519 217.451C79.0375 221.201 55.1937 214.917 52 224L62 222L62 241C71.4191 241 83.8145 238.301 89 248L91 246C100.266 266.515 95 296.638 95 319L102 319L102 320C93.1642 321.827 94.5506 330.056 103 331C94.9336 323.362 102.743 320.014 111 320L152 320C157.783 320 165.02 320.748 169.606 316.431C176.704 309.749 173 289.999 173 281L173 194C173 184.47 176.238 167.797 169.606 160.108C163.184 152.663 150.764 155 142 155L93 155C86.0503 155 76.5687 153.351 70.0039 155.894C63.4806 158.42 62.0557 164.766 62 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M162 155L163 156L162 155M364 155L364 158L365 158L364 155M165 156L166 157L165 156M66 157L67 158L66 157M455 162L452 161C446.668 171.608 450.447 182.124 460 189L458 186L480 190L479 192C491.849 182.431 482.779 165.522 471 159.403C465.584 156.589 457.626 155.308 455 162M65 158L66 159L65 158M363 158L364 159L363 158M64 159L65 160L64 159M361 159L362 160L361 159M359 160L360 161L359 160M63 161L64 162L63 161M356.667 161.333L357.333 161.667L356.667 161.333M171 162L172 163L171 162M354.667 162.333L355.333 162.667L354.667 162.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M453 162L453 167L454 167L453 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M62 163L63 164L62 163M353 163L354 164L353 163M172 164L173 165L172 164M350.667 164.333L351.333 164.667L350.667 164.333M348.667 165.333L349.333 165.667L348.667 165.333M346.667 166.333L347.333 166.667L346.667 166.333M173 167L173 310L174 310L174 210C174 197.794 177.707 178.218 173 167M344.667 167.333L345.333 167.667L344.667 167.333M342.667 168.333L343.333 168.667L342.667 168.333M317 169L318 170L317 169M340.667 169.333L341.333 169.667L340.667 169.333M52 170L53 171L52 170M338.667 170.333L339.333 170.667L338.667 170.333M336.667 171.333L337.333 171.667L336.667 171.333M334.667 172.333L335.333 172.667L334.667 172.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M83 173L84 174L83 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M332.667 173.333L333.333 173.667L332.667 173.333M425 173L425 215L426 215L425.004 187L425 173M15 174L16 175L15 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M84 174L84 206L85 206C85 197.519 88.1374 181.244 84 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M303.667 174.333L304.333 174.667L303.667 174.333M330.667 174.333L331.333 174.667L330.667 174.333M297 175L298 176L297 175M328.667 175.333L329.333 175.667L328.667 175.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M428 175L428 212L429 212C429 201.351 432.111 184.798 428 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M290 176L291 177L290 176M326.667 176.333L327.333 176.667L326.667 176.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M85 177C85 185.736 88.7175 206.906 82.4823 213.682C77.1201 219.509 56.3336 216.579 49 216L49 241C51.4985 235.048 48.4864 224.34 53.564 219.603C56.3407 217.013 60.7013 218.518 64 218.83C69.8184 219.381 81.5056 219.731 86.8519 217.397C90.7764 215.683 89.9984 210.499 90 207C90.0033 199.607 93.5866 179.782 85 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M283.667 177.333L284.333 177.667L283.667 177.333M324.667 177.333L325.333 177.667L324.667 177.333M341 177L342 178L341 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M342 177L342 178L360 178L342 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M276 178L277 179L276 178M322.667 178.333L323.333 178.667L322.667 178.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M341 178L341 312C345.557 312.846 356.581 314.712 359.972 310.397C361.768 308.113 361 303.702 361 301L361 276C361 243.297 360 210.644 360 178L341 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M268.667 179.333L269.333 179.667L268.667 179.333M320.667 179.333L321.333 179.667L320.667 179.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M360 179L361 269L360 312C365.362 307.314 362 287.032 362 280C362 254.034 364.327 226.778 361.285 201C360.464 194.04 362.721 185.484 360 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M89 180L90 181L89 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M318 180L319 181L318 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M425 180L425 199L426 199L425 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M316.667 181.333L317.333 181.667L316.667 181.333M314 182L315 183L314 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M302 183L302 184L306 184L302 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M309.667 183.333L310.333 183.667L309.667 183.333M255 184L256 185L255 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M296 184L297 185L296 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M304.667 184.333L305.333 184.667L304.667 184.333M253 185L254 186L253 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M289.667 185.333L290.333 185.667L289.667 185.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M297 185L297 186L300 186L297 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M458 186C462.037 191.144 467.654 193.141 474 194L474 193L471 193L471 192L475 192L458 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M251 186L252 187L251 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M281 186L281 187L284 187L281 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M290 186L290 187L293 187L290 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M426 186L426 193L427 193L426 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M283 187L283 188L286 188L283 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M267 188L267 189L270 189L267 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M276.667 188.333L277.333 188.667L276.667 188.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M265.667 189.333L266.333 189.667L265.667 189.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M269.667 189.333L270.333 189.667L269.667 189.333M244 190L245 191L244 190M266 190L267 191L266 190M462 190L463 191L462 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M478.667 190.333L479.333 190.667L478.667 190.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M242 191L243 192L242 191M264 191L265 192L264 191M464 191L465 192L464 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M475 191L477 193L477 191L475 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M477 191L478 192L477 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M478 191L479 192L478 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M262 192L263 193L262 192M466 192L467 193L466 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M471.667 192.333L472.333 192.667L471.667 192.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M473 192L473 193L476 193L473 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M477 192L478 193L477 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M260 193L261 194L260 193M469.667 193.333L470.333 193.667L469.667 193.333M474 193L475 194L474 193M258 194L259 195L258 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M313 194L314 195L313 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M314.603 195.028C310.154 198.552 313 216.62 313 222L313 284C313 290.873 310.551 303.478 313.603 309.682C315.377 313.286 328.53 313.243 331.397 310.972C335.846 307.448 333 289.38 333 284L333 224C333 216.004 335.037 204.776 332.566 197.148C331.122 192.689 317.846 192.46 314.603 195.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M256 195L257 196L256 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M332 195L333 196L332 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M233 196L234 197L233 196M255 196L256 197L255 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M333 196L333 272L332 312C336.864 307.75 334 291.287 334 285L334 223C334 214.993 336.105 203.4 333 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M231 197L232 198L231 197M253 197L254 198L253 197M251 198L252 199L251 198M418 218L419 218C418.83 237.061 405.534 232.33 393 236C400.633 243.529 416.317 242.127 421.543 231.985C425.883 223.563 422.6 211.646 416.7 205.022C402.858 189.481 368.569 206.501 380.858 225.957C389.486 239.617 413.016 229.516 418 218M249 199L250 200L249 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M370 199L370 200L388 200L370 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M247 200L248 201L247 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M369 200L369 312L388 312C388 293.251 390.601 273.606 388.83 255C388.274 249.159 385.312 237.687 391 234L391 233C369.584 226.638 384.497 211.843 388 200L369 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M245.667 201.333L246.333 201.667L245.667 201.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M368 201L368 311L369 311L369 234L368 201M388 201L389 202L388 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M411 201L414 207L415 207L411 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M222 202L223 203L222 202M244 202L245 203L244 202M361 202L362 203L361 202M220 203L221 204L220 203M242 203L243 204L242 203M240 204L241 205L240 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M385 204L386 205L385 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M238 205L239 206L238 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M384 205L385 206L384 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M218 206L219 207L218 206M236 206L237 207L236 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M84 207L84 211L85 211L84 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M234.667 207.333L235.333 207.667L234.667 207.333M233 208L234 209L233 208M216 209L217 210L216 209M231 209L232 210L231 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M381 209L382 210L381 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M229 210L230 211L229 210M227 211L228 212L227 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M380 211L381 212L380 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M83.3333 212.667L83.6667 213.333L83.3333 212.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M426 212L426 236L427 236L426 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M225 213L226 214L225 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M258 213L258 312L277 312L276 213L258 213M82 214L83 215L82 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M213 214L214 215L213 214M224 214L225 215L224 214M257 214L257 217L258 217L257 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M276 214L277 312L278 312L278 246L276 214M379 214L380 215L379 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M81 215L82 216L81 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M277 215L277 227L278 227L277 215M20 216L21 217L20 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M21 216L21 217L49 217L21 216M53 216L53 217L62 217L53 216M89 216L90 217L89 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M223 216L224 217L223 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M88 217L89 218L88 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M211 217L212 218L211 217M222 217L223 218L222 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M52 221L67 220C62.5236 217.849 55.0518 216.293 52 221M73 218L73 219L81 219L73 218M82.6667 218.333L83.3333 218.667L82.6667 218.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M362 218L362 241L363 241L362 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M418 218C411.114 229.168 400.737 231.999 388 232L388 233L391 233L391 234L388 234L388 253L389 253L390 235C400.058 235.001 425.854 236.76 418 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M221 219L222 220L221 219M209 220L210 221L209 220M220 221L221 222L220 221M52 226L62 224C58.8416 220.386 54.0659 222.254 52 226M219 222L220 223L219 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M51 223L50 241L52 241L51 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M379 223L380 224L379 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M218 224L219 225L218 224M206 225L207 226L206 225M217 226L218 227L217 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M285 312L286 312L286 227C290.455 227 299.998 225.205 303.397 228.603C307.138 232.345 305 244.068 305 249C305 268.832 308.595 292.702 304 312C307.899 308.593 306 298.901 306 294L306 245C306 240.335 308.142 228.913 302.852 226.603C299.528 225.152 287.459 224.546 285.603 228.318C282.657 234.306 285 246.373 285 253L285 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M216 227L217 228L216 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M286 227L286 312L303.972 310.397L305 292L305 246L303.972 228.603L286 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M381 227L382 228L381 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M204 228L205 229L204 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M382 228L383 229L382 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M215 229L216 230L215 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M383 229L384 230L383 229M384.667 230.333L385.333 230.667L384.667 230.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M439 268L445 270L444 268L449 269L455 266L456 265L455 263L459 262L460 261L459 259L461 259L462 257L461 254C464.981 250.521 462.453 242.93 460.005 239.001C454.752 230.566 444.332 227.941 435 230.638C415.713 236.213 417.891 270.004 439 268M214 231L215 232L214 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M386.667 231.333L387.333 231.667L386.667 231.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M213 232L214 233L213 232M201 233L202 234L201 233M212 234L213 235L212 234M390 235L390 238L391 238L390 235M199 236L200 237L199 236M211 236L212 237L211 236M210 237L211 238L210 237M209 239L210 240L209 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M230 239L230 240L248 240L230 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M389 239L389 257L390 257L389 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M230 240L230 312L249 312L249 240L230 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M249 240L249 312L250 312L250 263L249 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M82 241L83 242L82 241M196 241L197 242L196 241M208 241L209 242L208 241M85 242L86 243L85 242M207 242L208 243L207 242M86 243L87 244L86 243M87 244L88 245L87 244M194 244L195 245L194 244M206 244L207 245L206 244M88 246L88 330L89 330L89 272L88 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M90 246L92 248L90 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M205 246L206 247L205 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M90 247L90 321L98 320L98 319L95 319C95 301.718 95.7166 284.264 94.9606 267C94.6731 260.434 95.1604 251.554 90 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M192 247L193 248L192 247M204 247L205 248L204 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M89 248C89 280.757 92.9889 316.741 87 349L88 349L91 330L107 332L107 331C98.8237 330.926 90.6547 323.953 102 320L102 319L90 321L90 271L89 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M203 249L204 250L203 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M93 250L94 251L93 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M257 250L258 251L257 250M202 251L203 252L202 251M191 252L192 253L191 252M201 252L202 253L201 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M94 253L94 263L95 263L94 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M200 254L201 255L200 254M257 254L257 280L258 280L257 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M461.333 254.667L461.667 255.333L461.333 254.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M193 255L194 256L193 255M199 256L200 257L199 256M198 257L199 258L198 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M389 257L389 270L390 270L389 257M460 257L461 258L460 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M195 258L196 259L195 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M459 259L460 260L459 259M458 260L459 261L458 260M457.333 261.667L457.667 262.333L457.333 261.667M426 262L426 324L427 324L427 264L430 266L426 262M455.667 263.333L456.333 263.667L455.667 263.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M427 264L426 326L428 328L429 328C428.099 309.009 434.613 281.648 427 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M454 264L455 265L454 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M428 265L428 271L429 271L428 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M453 265L454 266L453 265M451.667 266.333L452.333 266.667L451.667 266.333M448 267L448 268L451 268L448 267M436 268L436 269L439 269L436 268M444 268L444 269L448 269L444 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M389 270L389 288L390 288L389 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M388 276L388 312L389 312C389 301.613 392.011 285.56 388 276M257 280L257 311L258 311L257 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M250 307L251 308L250 307M250.333 309.667L250.667 310.333L250.333 309.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M313 311L314 312L313 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M368 311L369 312L368 311M172.333 312.667L172.667 313.333L172.333 312.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M231 312L231 313L247 313L231 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M247 312L247 313L250 313L247 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M259 312L259 313L274 313L259 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M274 312L274 313L278 313L274 312M286 312L287 313L286 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M287 312L287 313L302 313L287 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M302 312L302 313L306 313L302 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M314 312L314 313L330 313L314 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M330 312L330 313L334 313L330 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M342.667 312.333L343.333 312.667L342.667 312.333M353 312L353 313L358 313L353 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M358 312L358 313L362 313L358 312M369 312L370 313L369 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M370.667 312.333L371.333 312.667L370.667 312.333M382 312L382 313L385 313L382 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M385 312L385 313L388 313L385 312M373 313L373 314L379 314L373 313M171 314L172 315L171 314M168 317L169 318L168 317M167 318L168 319L167 318M163.667 319.333L164.333 319.667L163.667 319.333M102 320L102 321L153 321C139.873 315.492 116.311 320 102 320M100.667 321.333L101.333 321.667L100.667 321.333M99 322C98.1172 325.304 98.0431 327.08 101 329L99 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M428.333 323.667L428.667 324.333L428.333 323.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M425 326L426 327L425 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M426 326C420.307 333.82 411.724 332 403 332L344 332L180 332C150.98 332 119.558 335.381 91 330L90 336L212 336L213.603 345.972L229 347L268 349L268 336L390 336C401.278 336 424.991 340.869 428 326L426 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M425 327L426 328L425 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M423 328L422 330L423 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M424 328L425 329L424 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M101.667 329.333L102.333 329.667L101.667 329.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M423 329L424 330L423 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M427 329L428 330L427 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M103 330L103 331L195 331L167 330L103 330M275 330L275 331L421 331C409.544 326.193 389.468 330 377 330L275 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M421 330L422 331L421 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M422 330L423 331L422 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M107 331L107 332L405 332L378 331L317 331L107 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M405 331L405 332L408 332L405 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M408 331L409 332L408 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M409 331L410 332L409 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M410 331L411 332L410 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M411 331L412 332L411 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M412 331L413 332L412 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M413 331L413 332L422 332L413 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M426 331L427 332L426 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M425 332L426 333L425 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M424 333L425 334L424 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M422 334L423 335L422 334M420 335L421 336L420 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M90 336L90 337L211 337C201.211 332.892 184.634 336 174 336L90 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M211 336L211 342L212 342L211 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M268 336L269 337L268 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M269 336L269 337L418 337C406.306 332.093 385.73 336 373 336L269 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M211 342L211 353L212 353L211 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M212 346C211.733 358.921 208.001 368.371 201 379C224.403 373.428 254.599 373.431 278 379L269.131 360L266.397 349.028L253.001 347.833L212 346M86 349L87 350L86 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M268 354L269 355L268 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M268 355L268 358L269 358L268 355M210.333 359.667L210.667 360.333L210.333 359.667M269 361L270 362L269 361M209 363L210 364L209 363M270 365L271 366L270 365M208 366L209 367L208 366M207 369L208 370L207 369M272 370L273 371L272 370M206 371L207 372L206 371M273 372L274 373L273 372M204 374L205 375L204 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c4181",
      stroke: "none"
    },
    d: "M181 385L181 390L185 390L184 386L295 386L295 390L297 390C296.189 379.824 274.483 378.195 266.424 378.15C254.765 378.086 243.894 374.218 232 375.09C222.951 375.754 210.716 376.407 202 378.609C195.022 380.371 188.148 384.221 181 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M275 375L276 376L275 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M276 376L277 377L276 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M200 378L201 379L200 378M278 378L279 379L278 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M198 379L199 380L198 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M199 379L200 380L199 379M279 379L280 380L279 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M280 379L281 380L280 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M196 380L197 381L196 380M282 380L283 381L282 380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M192 381L193 382L192 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M193 381L194 382L193 381M285 381L286 382L285 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M286 381L287 382L286 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M189 382L190 383L189 382M288 382L289 383L288 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M289 382L290 383L289 382M185 383L186 384L185 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M186 383L187 384L186 383M291.667 383.333L292.333 383.667L291.667 383.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M293 383L294 384L293 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M182 384L183 385L182 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M183 384L182 386L184 386L183 384M295 384L296 385L295 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M296 384L297 385L296 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M184 386L183 390L183 391L295 391L295 386L184 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M182 390L183 391L182 390M295 390L296 391L295 390M136 395L136 396L340 396L320 395L279 395L136 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M135.3 397.028C131.607 399.185 118.82 415.074 123.608 418.972C126.486 421.315 133.515 420 137 420L174 420L304 420L338 420C341.285 420 347.668 421.19 350.392 418.972C353.762 416.229 349.537 410.586 347.999 408C340.746 395.804 336.668 396 323 396L187 396L151 396C146.478 396 139.338 394.669 135.3 397.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M132 412C142.159 411.999 147.639 407.294 150 397C140.231 397.008 135.419 402.982 132 412M147 412L157 412L163 397C153.589 397.007 148.802 402.653 147 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M167 397L168 398L167 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M161 412L171 412L176 397C166.689 397.033 162.592 403.068 161 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M180 397L181 398L180 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M175 412L270 412C269.977 403.522 269.699 394.845 259 398L260 408L256 408C255.991 394.511 246.001 394.503 246 408L242 408L242 397C233.735 397.029 232.622 400.132 232 408L228 407L229 397L220 397L218 408L214 407L216 398C204.387 394.574 208.533 406.608 200 407L203 398C192.029 394.765 194.404 404.018 187 408L190 398C179.911 395.025 177.016 403.514 175 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M202 397L203 398L202 397M215 397L216 398L215 397M233 397L234 398L233 397M246 397L247 398L246 397M268 397L269 398L268 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M273 397C273.029 407.558 273.852 411.999 285 412C283.2 403.275 283.128 397.036 273 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M281 397L282 398L281 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M286 397C286.454 407.409 288.359 411.999 299 412L295 397L286 397M299 397C300.511 407.229 302.376 411.999 313 412C311.59 402.591 308.761 397.008 299 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M312 397L313 398L312 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M312 398L317 412L327 412C325.48 403.474 321.674 395.148 312 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M325 397L326 398L325 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f3ef",
      stroke: "none"
    },
    d: "M325 398L331 412L341 412C339.449 403.307 334.637 395.159 325 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M133 398L134 399L133 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M140 398L141 399L140 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M153 398L154 399L153 398M176 398L177 399L176 398M206 398L207 399L206 398M242.333 398.667L242.667 399.333L242.333 398.667M255 398L256 399L255 398M272.333 398.667L272.667 399.333L272.333 398.667M285 398L286 399L285 398M308 398L309 399L308 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M132 399L133 400L132 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M166 399L167 400L166 399M189 399L190 400L189 399M219 399L220 400L219 399M295 399L296 400L295 399M325 399L326 400L325 399M335 399L336 400L335 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M152 400L153 401L152 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M175.333 400.667L175.667 401.333L175.333 400.667M192 400L193 401L192 400M215 400L215 403L216 403L215 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M219 400L220 401L219 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M259 400L259 403L260 403L259 400M282 400L283 401L282 400M299 400L300 401L299 400M322 400L323 401L322 400M343 400L344 401L343 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M138 401L139 402L138 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M148 401L149 402L148 401M205.333 401.667L205.667 402.333L205.333 401.667M232 401L232 404L233 404L232 401M242 401L243 402L242 401M309 401L310 402L309 401M326 401L327 402L326 401M336 401L337 402L336 401M130 402L131 403L130 402M161 402L162 403L161 402M178 402L179 403L178 402M188 402L189 403L188 402M286 402L287 403L286 402M296 402L297 403L296 402M313 402L314 403L313 402M323 402L324 403L323 402M344 402L345 403L344 402M150 403L151 404L150 403M160.333 403.667L160.667 404.333L160.333 403.667M191 403L192 404L191 403M201.333 403.667L201.667 404.333L201.333 403.667M269 403L270 404L269 403M300.333 403.667L300.667 404.333L300.333 403.667M310 403L311 404L310 403M327 403L328 404L327 403M177 404L178 405L177 404M187.333 404.667L187.667 405.333L187.333 404.667M218.333 404.667L218.667 405.333L218.333 404.667M283.333 404.667L283.667 405.333L283.333 404.667M324 404L325 405L324 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M409 404C411.428 412.202 426.216 416.32 434 417L409 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M128 405L129 406L128 405M135 405L136 406L135 405M149 405L150 406L149 405M173 405L174 406L173 405M228.333 405.667L228.667 406.333L228.333 405.667M273 405L274 406L273 405M328 405L329 406L328 405M346 405L347 406L346 405M145 406L146 407L145 406M162 406L163 407L162 406M176 406L177 407L176 406M190 406L191 407L190 406M200 406L201 407L200 406M204 406L205 407L204 406M214 406L215 407L214 406M287.333 406.667L287.667 407.333L287.333 406.667M301.333 406.667L301.667 407.333L301.333 406.667M325 406L326 407L325 406M339 406L340 407L339 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M172 407L173 408L172 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M187 407L187 408L190 408L187 407M201 407L201 408L204 408L201 407M215 407L215 408L218 408L215 407M229 407L229 408L232 408L229 407M242 407L242 408L246 408L242 407M256 407L256 408L260 408L256 407M315 407L316 408L315 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M329 407L330 408L329 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M347 407L348 408L347 407M409 407C413.04 414.776 426.809 417.826 435 418L435 417L409 407M126 408L127 409L126 408M133 408L134 409L133 408M144 408L145 409L144 408M147 408L148 409L147 408M158 408L159 409L158 408M161 408L162 409L161 408M312 408L313 409L312 408M326 408L327 409L326 408M340 408L341 409L340 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M125 409L126 410L125 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M143 409L144 410L143 409M157 409L158 410L157 409M171.333 409.667L171.667 410.333L171.333 409.667M175 409L176 410L175 409M270 409L270 412L271 412L270 409M284 409L285 410L284 409M316.333 409.667L316.667 410.333L316.333 409.667M330.333 409.667L330.667 410.333L330.333 409.667M146.333 410.667L146.667 411.333L146.333 410.667M160.333 410.667L160.667 411.333L160.333 410.667M288.333 410.667L288.667 411.333L288.333 410.667M302 410L303 411L302 410M341.333 410.667L341.667 411.333L341.333 410.667M142 411L143 412L142 411M274 411L275 412L274 411M327 411L328 412L327 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M412 411L413 412L412 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M123 412L124 413L123 412M133 412L133 413L142 413L133 412M147 412L147 413L156 413L147 412M161 412L161 413L170 413L161 412M176 412L176 413L270 413L241 412L176 412M275 412L275 413L284 413L275 412M289 412L289 413L298 413L289 412M304 412L304 413L313 413L304 412M318 412L318 413L327 413L318 412M332 412L332 413L341 413L332 412M350 412L351 413L350 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M414 412L415 413L414 412M458 413L456 416C458.39 416.012 459.117 415.313 458 413M419 414L420 415L419 414M422 415L423 416L422 415M425 416L426 417L425 416M449 416L449 417L455 418L449 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M454 416L454 417L457 417L454 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4d36a",
      stroke: "none"
    },
    d: "M428 417L429 418L428 417M433 418L433 419L446 419L433 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M443 417L443 418L450 418L443 417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7868ea",
      stroke: "none"
    },
    d: "M450.667 417.333L451.333 417.667L450.667 417.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d87fc3",
      stroke: "none"
    },
    d: "M452.667 417.333L453.333 417.667L452.667 417.333M437 418L437 419L442 419L437 418M122 419L123 420L122 419M351 419L352 420L351 419z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb5);
export default __webpack_public_path__ + "static/media/db5.bbbabe6853d3b6135ce833ca2ad770c3.svg";
export { ForwardRef as ReactComponent };